import { createApp, h } from "vue"
import { Vue3Mq } from "vue3-mq"
import Bugsnag from "@bugsnag/js"
import BugsnagPluginVue from "@bugsnag/plugin-vue"
import { configure } from "vue-gtag"
import { setupCalendar } from "v-calendar"

import "~/scss/main.scss"

import { version } from "~package"
import i18n from "~/i18n"
import icons from "~/icons"
import { BREAKPOINTS } from "~/lib/constants"
import { ScreenSizePlugin } from "front-toolkit/plugins/ScreenSizePlugin"
import ListenersPlugin from "front-toolkit/plugins/ListenersPlugin"
import { PopupPlugin } from "front-toolkit/plugins/PopupPlugin"
import UtilitiesPlugin from "~/plugins/UtilitiesPlugin"
import router from "~/router"
import store from "~/store"
import "front-toolkit/InputRich.css"

// Highcharts
import Highcharts from "highcharts"
import "highcharts/modules/exporting"
import "highcharts/modules/export-data"
import "highcharts/modules/accessibility"
import "highcharts/modules/no-data-to-display"
import "highcharts/modules/pattern-fill"

Highcharts.setOptions({
    exporting: {
        enabled: false, // Hides the button, but API methods are still available. We implement our own export menu.
    },
})

import App from "~/App"
import LoadingSpinner from "~/components/LoadingSpinner"
;(async () => {
    if (import.meta.env.VITE_ENABLE_BUGSNAG === "true") {
        Bugsnag.start({
            apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
            appVersion: version,
            plugins: [new BugsnagPluginVue()],
        })
    }

    const spinner = createApp(() => {
        return h(
            "div",
            {
                class: "d-flex justify-content-center align-items-center vh-100",
            },
            [h(LoadingSpinner)]
        )
    })
    spinner.use(UtilitiesPlugin)
    spinner.mount("#app")

    await store.dispatch("welcomeBack")
    spinner.unmount()

    const app = createApp(App)

    const mql = window.matchMedia("(min-width: 1024px)")

    app.use(i18n)
    app.use(router)
    app.use(store)
    app.use(UtilitiesPlugin)
    app.use(ListenersPlugin)
    app.use(ScreenSizePlugin, { mql })
    app.use(PopupPlugin, { mql })
    app.use(Vue3Mq, {
        global: true,
        breakpoints: BREAKPOINTS,
        defaultBreakpoint: mql.matches ? "sm" : "s",
    })
    app.use(setupCalendar, {})
    if (import.meta.env.VITE_ENABLE_BUGSNAG === "true") {
        app.use(Bugsnag.getPlugin("vue"))
    }
    app.use(icons)

    const { googleAnalyticsAccount } = store.state.configs
    if (googleAnalyticsAccount) {
        const enabled = store.getters["cookies/googleAnalyticsIsEnabled"]
        configure({
            tagId: googleAnalyticsAccount,
            initMode: enabled ? "auto" : "manual",
            pageTracker: {
                router,
            },
        })
    }

    app.mount("#app")
})()
